import classNames from "classnames";
import React from "react";
import { DoorIconProps } from "./DeKaap";

export const DeBlaak: React.FC<DoorIconProps> = ({ isActive = false }) => {
  return (
    <svg
      width={28}
      height={60}
      viewBox="0 0 28 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={classNames("gg-transition gg-ease-in-out gg-duration-150", {
          "gg-fill-[#292747]": isActive,
          "gg-fill-[#9493A3]": !isActive,
        })}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.273 2H2v17.773h23.273V2Zm2 17.773V60H0V0h27.273v19.773ZM2 20.454v19.773h23.273V20.455H2ZM25.273 58V40.91H2V58h23.273Z"
        fill="#9493A3"
      />
    </svg>
  );
};
